/**
 * @method sterilizeFunction
 * @description Sterilizes an array of strings by removing any items that are not present in a predefined set of actions.
 * @param items - The array of strings to be sterilized.
 * @returns The sterilized array containing only the items that are present in the predefined set of actions.
 */
export const sterilizeFunction = (items: string[]) => {
  const actions = ['Notify', 'Compensate', 'Ignore', 'CompensateAndRecover'];
  const sterilizeArray: string[] = [];
  items.forEach((item) => {
    const lowercaseItem = item.toLocaleLowerCase();
    const matchingAction = actions.find((action) => action.toLocaleLowerCase() === lowercaseItem);
    if (matchingAction) {
      sterilizeArray.push(matchingAction);
    }
  });
  return sterilizeArray;
};
